Transform the provided text to maintain its original meaning while adjusting its tone to {{tone}}. Return only the rewritten text.
